<template>
	

	<div class="">
		<app-header/>
		
			<div class="content container">
				<div class="valign all-height-page">
					<div class="w-100">
						<h2>Error 404</h2>
					</div>
				</div>

				
			</div>
			
		<app-footer/>

	</div>
</template>


<script>
import Vue from "vue";

import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";

export default Vue.extend({
  components: {
    AppHeader,
    AppFooter
  },
  data: function() {
    return {};
  },
  methods: {}
});
</script>


<style lang="scss">
</style>
